import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@app/@core/directives/directives.module';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MasterdataModule } from '@pics-core/masterdata';
import { RbacOrgModule } from '@pics-core/rbac-org';
import { RbacPermissionsModule } from '@pics-core/rbac-permissions';
import { RbacUsersModule } from '@pics-core/rbac-users';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ConfigureSettingsModule } from './configure-settings/configure-settings.module';
import { GroupsRolesComponent } from './groups-roles/groups-roles.component';
import { ManagementGroupsComponent } from './management-groups/management-groups.component';
import { MastersComponent } from './masters/masters.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { RbacRoutingModule } from './rbac-routing.module';
import { UsersComponent } from './users/users.component';
import { MigrateUserComponent } from './migrateuser/migrateuser.component';
import { RbacMigrateUserModule } from '@pics-core/rbac-migrateuser';


@NgModule({
  declarations: [
    UsersComponent,
    MigrateUserComponent,
    PermissionsComponent,
    ManagementGroupsComponent,
    GroupsRolesComponent,
    MastersComponent
  ],
  imports: [
    CommonModule,
    RbacRoutingModule,
    FormsModule,
    PrimengModule,
    DirectivesModule,
    ReactiveFormsModule,
    NgbModule,
    ContextMenuModule,
    ConfirmPopupModule,
    RbacOrgModule,
    RbacUsersModule,
    RbacPermissionsModule,
    MasterdataModule,
    ConfigureSettingsModule,
    RbacMigrateUserModule
  ],
  exports: [MastersComponent],
  providers: [ConfirmationService]
})
export class RbacModule {}
